import React from 'react';

function TemplateIcon({color = '#000000', size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.00043 20.4999C4.83043 21.3299 6.17043 21.3299 7.00043 20.4999L20.0004 7.49994C20.8304 6.66994 20.8304 5.32994 20.0004 4.49994C19.1704 3.66994 17.8304 3.66994 17.0004 4.49994L4.00043 17.4999C3.17043 18.3299 3.17043 19.6699 4.00043 20.4999Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5098 8.98999L15.5098 5.98999"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 2.44L10.5 2L10.06 3.5L10.5 5L9 4.56L7.5 5L7.94 3.5L7.5 2L9 2.44Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 8.44L6.5 8L6.06 9.5L6.5 11L5 10.56L3.5 11L3.94 9.5L3.5 8L5 8.44Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20 13.44L21.5 13L21.06 14.5L21.5 16L20 15.56L18.5 16L18.94 14.5L18.5 13L20 13.44Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TemplateIcon;
